import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Options } from 'src/models/optionsOuvidoria';
import { ApiService } from 'src/app/api.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { emailValidator, phoneValidator, validaCEP } from 'src/app/shared/utils/app-validators';
import { Estado } from 'src/models/estadoCidade';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-ouvidoria',
  templateUrl: './ouvidoria.component.html',
  styleUrl: './ouvidoria.component.scss'
})
export class formOuvidoriaComponent implements OnInit, OnDestroy {
  formulario: any;
  submitMode = false;
  clientForm: FormGroup = new FormGroup({});
  submitted = false;
  quantidadeCaracteres: number = 0;
  listaEstados: Estado[] = [];
  listaCidades: any[] = [];
  formOuvidoria!: FormGroup;
  tokenRecapcha = '';
  fileTemp: File | null | undefined;

  estadoSelecionado: Estado = new Estado("0", "selecione", ['selecione o estado']);
  tokenRecapchaValid = false;
  private subscription!: Subscription;

  public optionsQuemSou: Options[] = [
    { id: 1, value: 'Público em geral', viewValue: 'Público em geral' },
    { id: 2, value: 'Varejo especializado', viewValue: 'Varejo especializado' },
    { id: 3, value: 'Varejo', viewValue: 'Varejo' },
    { id: 4, value: 'Instalador hidráulico', viewValue: 'Instalador hidráulico' },
    { id: 5, value: 'Estudante', viewValue: 'Estudante' },
  ];

  constructor(
    private swalService: SwalService,
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private apiService: ApiService,
    private recaptchaService: RecaptchaService
  ) { }

  saverange(event: any, form: string) {

    let textTemp = event.target.value;
    let text = textTemp.trim()
    if (form == 'nome') {
      this.formOuvidoria.controls['nome'].patchValue(text)
    } else if
      (form == 'endereco') {
      this.formOuvidoria.controls['endereco'].patchValue(text)
    } else if
      (form == 'email') {
      this.formOuvidoria.controls['email'].patchValue(text)
    } else if
      (form == 'bairro') {
      this.formOuvidoria.controls['bairro'].patchValue(text)
    } else if
      (form == 'mensagem') {
      this.formOuvidoria.controls['mensagem'].patchValue(text)
    }
  }

  ngOnInit() {
    this.formOuvidoria = this.fb.group({
      quemSou: ['', [Validators.required]],
      nome: ['', [Validators.required, Validators.minLength(3)]],
      email: [null, Validators.compose([Validators.required, emailValidator])],
      telefone: [null, Validators.compose([Validators.required, Validators.minLength(9), phoneValidator])],
      endereco: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      bairro: ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      arquivo: [''],
      cep: ['', Validators.compose([Validators.required, Validators.minLength(8), validaCEP])],
      estado: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      mensagem: ['', Validators.compose([Validators.required, Validators.minLength(20)])],
      recebeEmail: [false]

    })
    this.setEstadoCidade();
    this.verifyToken();
    this.swalService.avisoRecessoSwal();
  }

  aceitaReceberEmail(e: any) {
    this.formOuvidoria.controls['recebeEmail'].patchValue(e.target.checked);

  }

  setEstadoCidade() {
    this.apiService.loadEstadosCidades().subscribe(itens => {
      this.listaEstados = itens;

    })
    this.formOuvidoria.get('estado')?.valueChanges.subscribe(estado => {
      this.estadoSelecionado = estado;

      let listaTemp = []
      listaTemp = this.listaEstados.filter(element => {
        return element.nome == estado
      })
      this.listaCidades = []
      if (listaTemp.length) {
        this.listaCidades.push(listaTemp[0].cidades)
      }

    })
  }
  onFileSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    if (this.isFileTypeAllowed(file)) {
      this.fileTemp = file;
    } else {
      console.error('Invalid file type');
    }
  }

  private isFileTypeAllowed(file: File): boolean {
    const allowedTypes = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx'];
    const fileType = '.' + file.name.split('.').pop();

    return allowedTypes.includes(fileType.toLowerCase());
  }

  verifyFields(formAtual: string) {
    const dadosOuvidoria = {
      formulario: formAtual,
      quemSou: this.formOuvidoria.controls['quemSou'].value ? this.formOuvidoria.controls['quemSou'].value : '',
      nome: this.formOuvidoria.controls['nome'].value ? this.formOuvidoria.controls['nome'].value : '',
      email: this.formOuvidoria.controls['email'].value ? this.formOuvidoria.controls['email'].value : '',
      telefone: this.formOuvidoria.controls['telefone'].value ? this.formOuvidoria.controls['telefone'].value : '',
      endereco: this.formOuvidoria.controls['endereco'].value ? this.formOuvidoria.controls['endereco'].value : '',
      bairro: this.formOuvidoria.controls['bairro'].value ? this.formOuvidoria.controls['bairro'].value : '',
      cep: this.formOuvidoria.controls['cep'].value ? this.formOuvidoria.controls['cep'].value : '',
      cidade: this.formOuvidoria.controls['cidade'].value ? this.formOuvidoria.controls['cidade'].value : '',
      estado: this.formOuvidoria.controls['estado'].value ? this.formOuvidoria.controls['estado'].value : '',
      mensagem: this.formOuvidoria.controls['mensagem'].value ? this.formOuvidoria.controls['mensagem'].value : '',
      arquivo: this.formOuvidoria.controls['arquivo'].value ? this.formOuvidoria.controls['arquivo'].value : null,
      recebeEmail: this.formOuvidoria.controls['recebeEmail'].value ? this.formOuvidoria.controls['recebeEmail'].value : false,
      tokenRecapcha: this.tokenRecapcha
    }

    return dadosOuvidoria;

  }


  createNewForm(formulario: string) {

    let dadosForm = this.verifyFields(formulario);
    this.apiService.mensagensNew(dadosForm).subscribe(data => {
      let protocolo = data[0].protocolo

      if (protocolo) {
        this.swalService.fireSuccessSwal('Enviado com sucesso!', `Protocolo: ${protocolo}`).then(async (result: any) => {
          if (result.value) {
            this.submitted = false;
            this.formOuvidoria.reset();
            this.formOuvidoria.controls['quemSou'].patchValue('');
            this.formOuvidoria.controls['cidade'].patchValue('');
            this.formOuvidoria.controls['estado'].patchValue('');
            this.formOuvidoria.controls['arquivo'].patchValue('');
            this.fileTemp = null;

          }
        })
      }
      else {
        this.submitted = false;
        this.swalService.fireErrorSwal('Formulário não enviado', 'Tente novamente mais tarde.')
      }
    })
  }

  public send(form: any): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();
      }
      return;
    }

  }

  verifyToken() {
    this.subscription = this.recaptchaService.verifyTokenReCaptcha().subscribe(res => {
      this.tokenRecapchaValid = res.success;
    }, error => {
      console.error(error);
    });
  }

  onSubmit(formulario: string) {
    this.send(this.formOuvidoria);
    this.submitted = true;

    if(!this.tokenRecapchaValid){
      this.swalService.fireErrorSwal('Erro', 'Desculpe! Estamos com dificuldade em validar seus dados, pode ficar tranquilo que vamos trabalhar para resolver o problema o mais rapido possível. Ainda assim você pode usar outras alternativas como nos contatar diretamente pelo email falecom@blukit.com.br e se puder informe que teve problemas ao usar o site. Obrigado!');
      this.submitted = false;
      return;
    }

    if (!this.formOuvidoria.valid) {
      this.swalService.fireErrorSwal('Formulário não enviado', 'Existem campos obrigatórios não preenchidos.')
      this.submitted = false;
      return;
    }

    if (this.fileTemp) {
      let fd = new FormData();
      fd.append("file", this.fileTemp, this.fileTemp?.name);

      this.apiService.uploadFileAnexo(fd).subscribe(url => {
        if (url) {
          this.formOuvidoria.controls['arquivo'].patchValue(url[0]);
         this.createNewForm(formulario);
        }
      });
    } else {
      this.createNewForm(formulario);
    }

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  contarCaracteres(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const valorInput = inputElement.value;
    this.quantidadeCaracteres = 20 - (valorInput.length);
  }

}



